<template>
  <div class="box__price">
    <p>{{ $t("common.currency") }}</p>
    <div class="tumbler currency">
      <div
        v-for="money in getBoxCurrency"
        :key="money.currency"
        :class="tumblerClass(money.currency)"
        @click="changeCurrencyType(money.currency)"
      >
        <i :class="`icon icon-${icons[money.currency]}`"></i>
        <span>{{ getCurrencyAmount(money.currency) }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ShopItemBuyCurrency",
  props: {
    currentCurrency: String,
    boxContent: Object,
    currentBoxes: Number,
  },
  data() {
    return {
      icons: {
        soft: "free-points",
        hard: "paid-points",
      },
    };
  },
  computed: {
    getBoxCurrency() {
      return this.boxContent.conditions.currencies;
    },
  },
  mounted() {
    this.changeCurrencyType(this.getBoxCurrency[0].currency);
  },
  methods: {
    tumblerClass(type) {
      return ["tumbler__item", { "active button--corner": type === this.currentCurrency }];
    },
    changeCurrencyType(type) {
      this.$emit("changeCurrency", type);
    },
    getCurrencyAmount(type) {
      const currency = this.getBoxCurrency.filter(item => item.currency === type)[0];
      return currency.amount * this.currentBoxes;
    },
  },
};
</script>
